module.exports = __webpack_public_path__ + "school/img/practiceSeparateHistoryCultureThemeBg.93df39ba.jpg";